import { cn } from "@/lib/utils";

type TabBadgeProps = {
    count?: number;
    active?: boolean;
};

export function TabBadge({ count = 0, active }: TabBadgeProps) {
    if (!count || count <= 0) return null;

    return (
        <span
            className={cn(
                "ml-1 inline-flex items-center justify-center",
                "h-[12px] min-w-[12px] px-[2px]",
                "rounded-full text-[8px] font-semibold leading-none",
                active
                    ? "bg-white text-slate-900"
                    : "bg-slate-300 text-slate-700"
            )}
        >
            {count > 99 ? "99+" : count}
        </span>
    );
}